/** Banner links stay authoritative; a title alone never invents a destination. */
export function safeCustomerHref(value = ""): string {
  const href = value.trim();
  if (/^\/(?!\/)/.test(href) && !/[\\\s]/.test(href)) return href;
  try {
    const url = new URL(href);
    return ["https:", "http:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
}

export function parseCustomerIdentity(title = "", href = "") {
  let author = "";
  let alt = "";
  let structured = false;
  for (const segment of title.split(";")) {
    const match = segment.match(/^\s*(author|text)\s*:\s*(.*)$/i);
    if (!match) continue;
    structured = true;
    if (match[1].toLowerCase() === "author") author = match[2].trim();
    else alt = match[2].trim();
  }
  if (!structured) author = title.trim();
  author = author.replace(/^@+/, "");
  if (!author) {
    try {
      const url = new URL(href);
      const parts = url.pathname.split("/").filter(Boolean);
      if (
        /^(www\.)?instagram\.com$/i.test(url.hostname) &&
        parts.length === 1 &&
        !/^(p|reel|reels|stories|explore|accounts)$/i.test(parts[0])
      )
        author = parts[0];
    } catch {
      /* A missing link has no inferred identity. */
    }
  }
  return { author: author ? `@${author}` : "", alt };
}
